import React, { useState } from "react";
import { useOpenModal } from "#utils/openModal";
import { useMemoizedFn, useRequest } from "ahooks";
import { localPx2rem } from "#utils";
import { ProTablePlus } from "@bedrock/eed-react";
import { IProTableRef } from "@bedrock/eed-react/lib/components/ProTable/interface";
import { FilterType } from "@bedrock/eed-react/lib/components/ProFilter/interface";
import { demandRightsListCategoryTree, demandRightsPageContentList } from "#services/api";
import { queryDemandRightsPageContentList } from "./util";
import { $sType } from "@mpc/common";
import styles from './index.less'
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const useAddEquityModal = ({
  onOk,
  rowKey = 'rights_code',
  allRights = false,
}) => {
  const tableRef = React.useRef<IProTableRef<any>>();
  const [disabledRows, setDisabledRows] = useState([]);
  const [selectRows, setSelectedRows] = useState([]);
  const [rightsList, setRightsList] = useState([]);
  const {data: typeOptions} = useRequest(
    () => demandRightsListCategoryTree({}),
    {ready: $sType === 'inner'}
  );
  
  const columns = [
    {
      title: '权益内容',
      dataIndex: 'content',
      width: localPx2rem(342),
      className: 'fw-bold'
    },
    {
      title: '类别',
      dataIndex: 'category_name',
      width: localPx2rem(160),
    },
    {
      title: '类别',
      dataIndex: 'category_ids',
      hideInTable: true,
      searchRender: {
        showCondition: false,
        type: FilterType.SELECT_MULTIPLE,
        filterComponentProps: {
          options: typeOptions?.data?.tree,
          fieldNames: {
            label: 'name',
            value: 'id',
            children: 'children_demand_rights_category_list'
          }
        },
      }
    },
  ]

  const queryService = async (query) => {
    const params = query?.params;
    const { current, pageSize: limit, content_fuzzy, paramsWithConditions } = params;
    const conditions = Object.entries(paramsWithConditions).reduce((pre, [key, value]: [string, any]) => {
        pre[key] = value.value
      return pre
    }, {})
    try {
      const request = allRights ? demandRightsPageContentList : queryDemandRightsPageContentList
      const res = await request({
        current,
        limit,
        status: 1,
        ...conditions,
        content_fuzzy,
      }, rightsList)

      return {
        data: {
          list: res.data?.list?.map?.(v => ({
            ...v,
            rights_code: v.code,
            rights_id: v.id,
          })),
          total: res.data?.total_count,
        }
      }
    } catch (error) {
      console.log('error', error);
      return { data: { list: [], total: 0 } }
    }
  }


  const { open } = useOpenModal({
    title: '关联权益',
    width: localPx2rem(960),
    children: (<div className={cx('body-container')}>
      <ProTablePlus
        rowKey={rowKey}
        ref={tableRef}
        request={{ queryService }}
        columns={columns}
        pagination={{ pageSize: 10 }}
        toolbar={{
          filterSetting: {
            disableAddButton: true,
          },
          actionsInTitle: true,
          search: {
            placeholder: '请输入权益内容',
            id: 'content_fuzzy',
          },
        }}
        rowSelection={{
          selectedRowKeys: selectRows?.map?.(v => v[rowKey]),
          type: 'checkbox',
          disabledRowKeys: disabledRows?.map?.(v => v[rowKey]),
          onSelectAll: (selected, selectedRows) => {
            setSelectedRows(selectedRows);
          },
          onSelect: (row, selected) => {
            setSelectedRows((prev) => {
              if (prev.some(v => v[rowKey] === row[rowKey])) {
                return prev.filter((v) => v[rowKey] !== row[rowKey])
              }
              return [...prev, row]
            });
          },
        }}
      />
    </div>),
    onOk: () => onOk(selectRows.filter(v => !disabledRows.some(d => d[rowKey] === v[rowKey])))
  });

  return useMemoizedFn(({
    disabledRows,
    rightsList,
  }) => {
    setRightsList(rightsList);
    setDisabledRows(disabledRows);
    setSelectedRows(disabledRows);
    setTimeout(() => {
      open();
    }, 0)
  })
}

export default useAddEquityModal;